import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    meetinsights: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_MEETINSIGHTS_SELECT_IDS (store, ids) {
      store.meetinsights.selectIds = ids
    },
    REMOVE_MEETINSIGHTS_SELECT_IDS (store, ids) {
      store.meetinsights.selectIds = store.meetinsights.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_MEETINSIGHTS_SELECT_ID (store, id) {
      store.meetinsights.selectId = id
    },
    SET_MEETINSIGHTS_FILTERS (store, filters) {
      store.meetinsights.filters = filters
    },
    SET_MEETINSIGHTS_PAGINATE (store, val) {
      store.meetinsights.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getMeetinsights: (store, getters) => {
      return store.meetinsights.selectIds.map((id) => {
        return getters['entities/meetinsights/find'](id)
      })
    },
    getMeetinsightsFilters: (store, getters) => {
      return store.meetinsights.filters
    },
    getMeetinsightsPaginate: (store, getters) => {
      return store.meetinsights.paginate
    },
    getMeetinsight: (store, getters) => {
      return getters['entities/meetinsights/find'](store.meetinsights.selectId) || {}
    }
  },
  actions: {
    /*
    selectMeetinsights
    */
    selectMeetinsights ({commit, dispatch, getters, state}, filters) {
      return dispatch('getMeetinsights', filters)
      .then((response) => {
        commit('SET_MEETINSIGHTS_FILTERS', filters)
        commit('SET_MEETINSIGHTS_PAGINATE', response)
        commit('SET_MEETINSIGHTS_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectMeetinsights
    */
    refreshSelectMeetinsights ({commit, dispatch, getters, state}) {
      return dispatch('selectMeetinsights', getters.getMeetinsightsFilters)
    },
    /*
    selectMeetinsight
    */
    selectMeetinsight ({commit, dispatch, getters, state}, id) {
      return dispatch('getMeetinsightById', id)
      .then((response) => {
        commit('SET_MEETINSIGHTS_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getMeetinsights
    */
    getMeetinsights ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/meetinsights`, {params: filters})
      .then((response) => {
        return dispatch('entities/meetinsights/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.meetinsights || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getMeetinsightById
    */
    getMeetinsightById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/meetinsights/${id}`)
      .then((response) => {
        return dispatch('entities/meetinsights/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.meetinsights[0]
      })
    },
    /*
    createMeetinsight
    */
    createMeetinsight ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/meetinsights`, data)
      .then((response) => {
        return dispatch('entities/meetinsights/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.meetinsights[0]
      })
    },
    /*
    updateMeetinsight
    */
    updateMeetinsight ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/meetinsights/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/meetinsights/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.meetinsights[0]
      })
    },
    /*
    deleteMeetinsight
    */
    deleteMeetinsight ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/meetinsights/${id}`)
      .then((response) => {
        commit('REMOVE_MEETINSIGHTS_SELECT_IDS', [id])
        dispatch('entities/meetinsights/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Meetinsight.js